export default "__VITE_ASSET__rdqv$BMT__"